import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.vars.palette.secondary.main,
  color: theme.vars.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.vars.palette.secondary.dark,
  },
  '&:active': {
    backgroundColor: theme.vars.palette.secondary.dark2,
  },
}))

function ButtonSecondary(props) {
  const { children } = props

  return <StyledButton {...props}>{children}</StyledButton>
}

export default ButtonSecondary
